import { MessageCircle } from "lucide-react";
import {
  buildWhatsAppUrl,
  generalMessage,
  productMessage,
  repairMessage,
  repairServiceMessage,
  sellMessage,
} from "@/lib/whatsapp";

const Base = ({ href, children, className = "btn-accent", testId, full }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    aria-label="Contact Mobile Specialist on WhatsApp"
    className={`${className} ${full ? "w-full" : ""}`}
  >
    <MessageCircle className="h-4 w-4" aria-hidden="true" />
    {children}
  </a>
);

export const WhatsAppButton = ({ label = "WhatsApp Us", message, className, testId = "whatsapp-btn", full }) => (
  <Base href={buildWhatsAppUrl(message || generalMessage())} className={className} testId={testId} full={full}>
    {label}
  </Base>
);

export const ProductWhatsAppButton = ({ product, full, className }) => (
  <Base
    href={buildWhatsAppUrl(productMessage(product))}
    testId="product-whatsapp-btn"
    full={full}
    className={className}
  >
    WhatsApp Enquiry
  </Base>
);

export const RepairWhatsAppButton = ({ device, problem, serviceName, label = "WhatsApp Enquiry", full, className, testId = "repair-whatsapp-btn" }) => (
  <Base
    href={buildWhatsAppUrl(serviceName ? repairServiceMessage(serviceName) : repairMessage({ device, problem }))}
    testId={testId}
    full={full}
    className={className}
  >
    {label}
  </Base>
);

export const SellPhoneWhatsAppButton = ({ data, label = "Get a Quote on WhatsApp", full, className, testId = "sell-whatsapp-btn" }) => (
  <Base href={buildWhatsAppUrl(sellMessage(data))} testId={testId} full={full} className={className}>
    {label}
  </Base>
);
